export default __webpack_public_path__ + "static/media/full-ent.b49af11c.jpg";